import React from "react";
import "../../../css/buttons/SecondaryButton.css";

const SecondaryButton = ({ onClick, text }) => {
  return (
    <button className="secondary-button" onClick={onClick}>
      <div className="button-text secondary">{text}</div>
    </button>
  );
};

export default SecondaryButton;
